import { render, staticRenderFns } from "./PlayButton.vue?vue&type=template&id=bec9d726"
import script from "./PlayButton.vue?vue&type=script&lang=js"
export * from "./PlayButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports